import PropTypes from "prop-types"
import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Notification from "./notification"
import { removeNotification } from "../../actions/notifications"

const Notifications = ({ actions, notifications }) => {
  const { removeNotification } = actions
  return (
    <ul className="notifications">
      {notifications.map(notification => {
        const { id } = notification
        return (
          <Notification {...notification} key={id} onDismissClick={() => removeNotification(id)} />
        )
      })}
    </ul>
  )
}

Notifications.propTypes = {
  actions: PropTypes.shape({
    removeNotification: PropTypes.func.isRequired
  }).isRequired,
  notifications: PropTypes.arrayOf(PropTypes.object).isRequired
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ removeNotification }, dispatch)
})

const mapStateToProps = state => ({
  notifications: state.notifications
})

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)


// WEBPACK FOOTER //
// ./src/components/notifications/notifications.js